export default {
  banner: {
    left: 'Left',
    right: 'Right',
  },
}



/** WEBPACK FOOTER **
 ** ../app/Translate/en.js
 **/